import React, { useMemo } from 'react';
import { Box, Heading, NavigationToggler, Option } from '@common-fe/common-fe';

import theme from '@/styles/theme';

import { REPORT_BUTTON_PORTAL_ID, REPORT_INFO_PORTAL_ID, ReportTab } from '../report.types';
import ReportFavoriteButton from '../ReportCard/ReportFavoriteButton';

interface Props {
  title: string;
  isNoSummaryMode?: boolean;
  testId?: string;
  tab: ReportTab;
  onSetTab: (value: ReportTab) => void;
  children?: React.ReactNode;
  isFavorite: boolean;
  onToggleFavorite: (value: boolean) => void;
  isPreviewMode?: boolean;
}

const ReportDetailsBase: React.FC<Props> = ({
  testId = 'report-details-base',
  isNoSummaryMode,
  tab,
  onSetTab,
  title,
  children,
  isFavorite,
  onToggleFavorite,
  isPreviewMode,
}) => {
  const TABS: Option[] = useMemo(
    () => [
      {
        key: ReportTab.Summary,
        title: isNoSummaryMode ? 'No summary' : 'Summary',
      },
      {
        key: ReportTab.Report,
        title: 'Report',
      },
    ],
    [isNoSummaryMode]
  );

  if (isPreviewMode) {
    return (
      <div>
        <Box width="100%">{children}</Box>
      </div>
    );
  }
  return (
    <div>
      <Box align="center" direction="column">
        <Box
          direction="row"
          align="center"
          data-testid={`${testId}_wrapper`}
          pad={{ horizontal: tab === ReportTab.Report ? '40px' : undefined }}
          justify="between"
          width={tab === ReportTab.Report ? '100%' : theme.defaultContentWidth}
        >
          <Box direction="column" fill>
            <Box direction="row" align="center" justify="between">
              <Box direction="row" align="center">
                <Heading level={1} size="regular" data-testid={`${testId}_title`}>
                  {title}
                </Heading>
                <Box margin={{ left: 'spacing12' }}>
                  <ReportFavoriteButton value={isFavorite} onChange={onToggleFavorite} />
                </Box>
              </Box>

              <Box id={REPORT_INFO_PORTAL_ID}></Box>
            </Box>

            <Box
              direction="row"
              justify="between"
              fill
              align="center"
              margin={{ bottom: 'spacing12', top: 'spacing12' }}
            >
              <NavigationToggler
                testId={`${testId}_tabs`}
                value={tab}
                options={TABS}
                onChange={(key) => onSetTab(key as ReportTab)}
              />
              <Box margin={{ left: 'spacing24' }} id={REPORT_BUTTON_PORTAL_ID}></Box>
            </Box>
          </Box>
        </Box>

        <Box width={tab === ReportTab.Report ? '100%' : theme.defaultContentWidth}>{children}</Box>
      </Box>
    </div>
  );
};

export default ReportDetailsBase;
